<div class="form-box-row">
  <label>
    {{ 'Greige_Code' | translateWF: 'Greige Code' }}
  </label>
  <strong>Greige-1</strong>
</div>

<div class="primary__card">
  <h5>
    {{ 'Composition' | translateWF: 'Composition' }}
  </h5>

  @if (fabricComposition.length > 0) {
    <!-- Dynamic color bar -->
    <div class="sample-color">
      <div
        *ngFor="let comp of fabricComposition"
        class="sample-color__item"
        [style.width.%]="comp.percentage"
        [style.background-color]="getCompositionColor(comp.compositionCode)"
      ></div>
    </div>

    <!-- Dynamic composition info -->
    <div class="info-compostion">
      <div class="info-composition__item" *ngFor="let comp of fabricComposition">
        <div>
          <span [style.background-color]="getCompositionColor(comp.compositionCode)"></span>
          <p>
            {{ comp.compositionCode }}
          </p>
        </div>
        <p>{{ comp.percentage }}%</p>
      </div>
    </div>
  } @else {
    <p>
      {{ 'NotYarnsAdded' | translateWF: 'Not Yarns Added Yet' }}
    </p>
  }
</div>
